import { type FC } from "react";

/**
 * ResponsumOSApp - landing page for the ResponsumOS workspace
 *
 * @returns ResponsumOSApp component
 *
 */
export const ResponsumOSApp: FC = () => {
  return <div className="p-4">ResponsumOS Workspace</div>;
};
